import { State } from "../pages/ScenarioDetail";

export const getAllStateNames = (states: Array<State>) => {
    return states.map((state) => state.name.replace(/\s/g, ""));
};
